module.exports = __webpack_public_path__ + "media/assets/images/blog/network_iot-small-bc12e7e785458f310f48c5cce422cddd.png";